/**
 *  @class
 *  @function CollectionTabs3
 */

if (!customElements.get('collection-tabs-3')) {
  class CollectionTabs3 extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        const mainTabs = Array.from(this.querySelectorAll('.collection-tabs-3__main-tab'));
        const tabGroups = Array.from(this.querySelectorAll('.collection-tabs-3__tab-group'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return;
        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);

        // Handle main tab clicks
        mainTabs.forEach((tab, i) => {
          tab.addEventListener('click', (event) => {
            // Immediate response - no delays
            this.toggleMainTabs(mainTabs, tabGroups, i);
            this.toggleLinks(links, i);
            
            // Handle scrolling with minimal delay
            const mainTabsContainer = this.querySelector('.collection-tabs-3__main-tabs');
            if (mainTabsContainer) {
              const tabCount = mainTabsContainer.querySelectorAll('.collection-tabs-3__main-tab').length;
              const hasOverflow = this.checkIfScrollingNeeded(mainTabsContainer);
              
              if (tabCount > 2 && hasOverflow) {
                // Only scroll if there's real overflow
                this.scrollToCenter(tab, mainTabsContainer);
              }
            }
            
            event.preventDefault();
          });
        });

        window.addEventListener('resize', () => {
          if (!this.slider) return;
          let flkty = Flickity.data(this.slider);
          flkty.resize();
          // Check if tabs need scrolling after resize
          this.checkScrollability();
        });

        // Check if main tabs need scrolling and apply appropriate styling
        const mainTabsContainer = this.querySelector('.collection-tabs-3__main-tabs');
        if (mainTabsContainer) {
          const tabCount = mainTabsContainer.querySelectorAll('.collection-tabs-3__main-tab').length;
          
          if (tabCount > 2) {
            // Only check scrollability if there are more than 2 tabs
            mainTabsContainer.classList.remove('few-tabs');
            const needsScrolling = this.checkIfScrollingNeeded(mainTabsContainer);
            if (needsScrolling) {
              mainTabsContainer.classList.add('scrollable');
            } else {
              mainTabsContainer.classList.remove('scrollable');
            }
          } else {
            // If 2 or fewer tabs, always center and never scrollable
            mainTabsContainer.classList.add('few-tabs');
            mainTabsContainer.classList.remove('scrollable');
          }
        }

        // Auto-select first collection on page load
        if (tabGroups.length > 0) {
          const firstMainTab = mainTabs[0];
          
          // Show products for first collection immediately
          if (firstMainTab && firstMainTab.dataset.collection) {
            this.toggleCollection(firstMainTab.dataset.collection);
          }
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const mainTabIndex = mainTabs.indexOf(event.target);
            if (mainTabIndex !== -1) {
              mainTabs[mainTabIndex].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 1);
    }

    toggleMainTabs(mainTabs, tabGroups, index) {
      // Store main tabs scroll position to prevent interference
      const mainTabsContainer = this.querySelector('.collection-tabs-3__main-tabs');
      const mainTabsScrollLeft = mainTabsContainer ? mainTabsContainer.scrollLeft : 0;
      
      // Remove active class from all main tabs and tab groups
      mainTabs.forEach((tab) => tab.classList.remove('active'));
      tabGroups.forEach((group) => group.classList.remove('active'));
      
      // Add active class to clicked main tab and its group
      mainTabs[index].classList.add('active');
      tabGroups[index].classList.add('active');
      
      // Show products for the selected collection immediately
      if (mainTabs[index].dataset.collection) {
        this.toggleCollection(mainTabs[index].dataset.collection);
      }
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    scrollToCenter(element, container) {
      if (!container || !element) return;
      
      // Get the element's position relative to the container
      const elementOffsetLeft = element.offsetLeft;
      const elementWidth = element.offsetWidth;
      const containerWidth = container.offsetWidth;
      const containerScrollWidth = container.scrollWidth;
      
      // Check if there's enough content to scroll
      const maxScrollLeft = containerScrollWidth - containerWidth;
      
      // If container doesn't need scrolling, don't do anything
      if (maxScrollLeft <= 0) return;
      
      // Get all tabs to determine if this is the last one
      const allTabs = container.querySelectorAll('.collection-tabs-3__main-tab');
      const isLastTab = element === allTabs[allTabs.length - 1];
      
      let finalScrollLeft;
      if (isLastTab) {
        // For the last tab, scroll to the end to ensure it's fully visible
        finalScrollLeft = maxScrollLeft;
      } else {
        // For other tabs, center them but don't exceed max scroll
        const scrollLeft = elementOffsetLeft - (containerWidth / 2) + (elementWidth / 2);
        finalScrollLeft = Math.min(scrollLeft, maxScrollLeft);
      }
      
      container.scrollTo({
        left: finalScrollLeft,
        behavior: 'smooth'
      });
    }

    checkIfScrollingNeeded(container) {
      if (!container) return false;
      
      // Force a reflow to get accurate measurements
      container.offsetHeight;
      
      // Get the actual scrollable width and visible width
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      
      // More robust tolerance for mobile browsers and different screen sizes
      const tolerance = window.innerWidth <= 768 ? 5 : 2;
      const needsScrolling = scrollWidth > (clientWidth + tolerance);
      
      return needsScrolling;
    }

    checkScrollability() {
      // Check main tabs - special logic for 2 or fewer tabs
      const mainTabsContainer = this.querySelector('.collection-tabs-3__main-tabs');
      if (mainTabsContainer) {
        const tabCount = mainTabsContainer.querySelectorAll('.collection-tabs-3__main-tab').length;
        
        if (tabCount > 2) {
          // Only check scrollability if there are more than 2 tabs
          mainTabsContainer.classList.remove('few-tabs');
          const needsScrolling = this.checkIfScrollingNeeded(mainTabsContainer);
          if (needsScrolling) {
            mainTabsContainer.classList.add('scrollable');
          } else {
            mainTabsContainer.classList.remove('scrollable');
          }
        } else {
          // If 2 or fewer tabs, always center and never scrollable
          mainTabsContainer.classList.add('few-tabs');
          mainTabsContainer.classList.remove('scrollable');
        }
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;
      const products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);
      const flkty = Flickity.data(slider);

      products.forEach((product) => { 
        product.classList.remove('carousel__slide'); 
        slider.append(product); 
      });
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      flkty.insert(activeProducts);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
    }
  }
  customElements.define('collection-tabs-3', CollectionTabs3);
}


